import { View } from "@carbon/icons-react";
import { Narrow, Pad } from "component/basics";
import { HelpBubble } from "component/help";
import { DeleteIcon } from "component/icon";
import { FeatureTreeNode, TopBar, TopBarActionProvider } from "component/topbar";
import { CHOOSEONE, COMPOSITE, FeatureGroup, SECTION, SUBSECTION } from "feature/feature-helpers";
import { CLICK, component, componentWithVariants, DemoBox, demoFile, POPUP, story, variant } from "system/demo";

demoFile('component/topbar', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6311-21920&t=MC9nppcf9h2iJDKP-1'
})

function DemoHelpBubble() {
    return <HelpBubble right condition={true} helpKey='below' text='The top bar can show a help bubble' />
}

componentWithVariants('TopBar', TopBar, {}, [
    variant('Non Admin', {
        state: { personaKey: 'a' }
    }, [
        story('Show Menu', [
            CLICK('account-menu')
        ]),
        story('Open Profile', [
            CLICK('account-menu'),
            POPUP(CLICK('Profile'))
        ]),
        story('Log out', [
            CLICK('account-menu'),
            POPUP(CLICK('Log out'))
        ])
    ]),
    variant('Admin', {
        structureKey: 'simplecomments',
        state: {
            roles: ['Editorial'],
        }
    }, [
        story('Toggle Config', [
            CLICK('account-menu'),
            POPUP(CLICK('Developer')),
            POPUP(CLICK('Show Config Slots'))
        ])
    ]),
    variant('with Beta tag', {
        state: {
            modulePublic: {isBeta: true}
        }
    }),
    variant('Beta tag not logged in', {
        state: {
            modulePublic: {isBeta: true},
            personaKey: null
        }
    }, [
        story('Log in', [
            CLICK('Log in')
        ])
    ]),
    variant('With Help Bubble', {
        config: {
            topBarHelpBubbles: [DemoHelpBubble]
        }
    })
])

function TopBarActionProviderDemo() {
    return <View>
        <TopBar />
        <TopBarActionProvider label='Post' onPress={() => {}} /> 
        <TopBarActionProvider secondary icon={<DeleteIcon />} type='delete' label='Delete' onPress={() => {}} /> 
        <Pad size={40} />
    </View>
}
component('TopBarActionProvider', TopBarActionProviderDemo);


export const DogFeature = { key: 'dog', name: 'Dog' }
export const CatFeature = { key: 'cat', name: 'Cat' }
export const KomodoDragonFeature = { key: 'komodo_dragon', name: 'Komodo Dragon' }
export const ColorPinkFeature = { key: 'color_pink', name: 'Pink', parentFeature: 'pet_sitting'}
export const ColorGreenFeature = { key: 'color_green', name: 'Green', parentFeature: 'pet_sitting' }
export const PetSittingFeature = { key: 'pet_sitting', name: 'Pet Sitting' }
export const GroomingFeature = { key: 'grooming', name: 'Grooming' }
export const WalkingFeature = { key: 'walking', name: 'Walking', parentFeature: 'pet_sitting' }


const demoFeatures = SECTION('Demo Feature Menu', [
    COMPOSITE(PetSittingFeature, [
        CHOOSEONE('Pet Type', [DogFeature, CatFeature, KomodoDragonFeature]),
        CHOOSEONE('Fur Dye Color', [ColorPinkFeature, ColorGreenFeature]),
        SUBSECTION('Radio in here has no title', [
            CHOOSEONE(null, [
                DogFeature,
                CatFeature,
                KomodoDragonFeature
            ])
        ]),
        SUBSECTION('Section with a toggle in it', [
            COMPOSITE(GroomingFeature, [
                DogFeature,
                CatFeature,
                KomodoDragonFeature
            ])
        ]),
        SECTION('Extra Services', [
            GroomingFeature,
            WalkingFeature
        ])
    ]),
]);

componentWithVariants('FeatureTreeNode', FeatureTreeNode, {}, [
    variant('Section', {args: {featureBlock:demoFeatures}}),
    variant('Composite', {args: {featureBlock:demoFeatures.features[0]}}),
    variant('ChooseOne', {args: {featureBlock:(demoFeatures.features[0] as FeatureGroup).features[0]}})
])

